import { getMomentTz } from "@dexteel/mesf-core";
import {
  ColDef,
  ColGroupDef,
  exportMultipleSheetsAsExcel,
} from "ag-grid-enterprise";
import { ExportGridRef } from "../../models/ProcessByShift";

const moment = getMomentTz();

export const exportMultipleGridsToExcel = (
  grids: ExportGridRef[],
  productionDate: Date,
) => {
  try {
    const spreadsheets = grids.map(({ gridApi, sheetName }) => {
      const columnDefs = gridApi.getColumnDefs();

      const filterColumns = (
        columns: (ColDef | ColGroupDef)[],
      ): (ColDef | ColGroupDef)[] => {
        return columns.reduce(
          (filteredColumns: (ColDef | ColGroupDef)[], column) => {
            if (column.headerName === "" || column.headerName === undefined) {
              return filteredColumns;
            }

            if ((column as ColGroupDef).children) {
              const group = column as ColGroupDef;
              group.children = filterColumns(group.children);
              if (group.children.length > 0) {
                filteredColumns.push(group as ColDef | ColGroupDef);
              }
            } else {
              filteredColumns.push(column);
            }
            return filteredColumns;
          },
          [],
        );
      };

      const filteredColumns = columnDefs ? filterColumns(columnDefs) : [];

      const columnKeys = filteredColumns
        .flatMap((column) => {
          if ((column as ColGroupDef).children) {
            return (column as ColGroupDef).children.map(
              (child) => (child as ColDef).field,
            );
          } else {
            return (column as ColDef).field;
          }
        })
        .filter((key) => key !== undefined);

      return gridApi.getSheetDataForExcel({
        sheetName,
        columnKeys,
        prependContent: [
          {
            cells: [
              {
                data: {
                  value: `${sheetName} Report ${moment(productionDate).format("MM-DD-YYYY")}`,
                  type: "String",
                },
                mergeAcross: 2,
              },
            ],
          },
        ],
        appendContent: [
          {
            cells: [
              {
                data: {
                  value: `Generated on: ${new Date().toLocaleString()}`,
                  type: "String",
                },
                mergeAcross: 2,
              },
            ],
          },
        ],
      });
    });

    exportMultipleSheetsAsExcel({
      data: spreadsheets.filter(
        (spreadsheet): spreadsheet is string => spreadsheet !== undefined,
      ),
      fileName: `production_reports_${moment(productionDate).format("MM-DD-YYYY")}.xlsx`,
    });
  } catch (error) {
    console.error("Error exporting to Excel:", error);
    throw error;
  }
};
